'use strict';

var basketCounter = {
    selector: '[data-basket-count]',
    endpoint: checkoutPath + '/basket-count',

    init: function() {
        var $counts = $(this.selector);
        if ($counts.length) {
            $.getJSON(this.endpoint, function(response) {
                if (window.location.href.indexOf('basket') === -1) {
                    $counts.text('(' + response + ')');
                } else if (response === 1) {
                    $counts.text(response + ' item');
                } else if (response > 1) {
                    $counts.text(response + ' items');
                }
                localStorage.removeItem('basket-data');
            });
        }
    }
};
